import api from "./api";
import { API_ROUTES } from "./apiRoutes";

export const getAmenities = async (societyId = "") => {
  const url = societyId 
    ? `${API_ROUTES.amenities.base}?society_id=${societyId}` 
    : API_ROUTES.amenities.base;
  const response = await api.get(url);
  return response.data?.data || [];
};

export const createAmenity = async (payload) => {
  const response = await api.post(API_ROUTES.amenities.base, payload);
  return response.data;
};

export const updateAmenity = async (id, payload) => {
  const response = await api.put(`${API_ROUTES.amenities.base}/${id}`, payload);
  return response.data;
};

export const bookAmenity = async (payload) => {
  const response = await api.post(`${API_ROUTES.amenities.base}/book`, payload);
  return response.data;
};

export const getAmenityBookings = async (societyId = "") => {
  const url = societyId 
    ? `${API_ROUTES.amenities.base}/bookings?society_id=${societyId}` 
    : `${API_ROUTES.amenities.base}/bookings`;
  const response = await api.get(url);
  return response.data?.data || [];
};

export const getMyAmenityBookings = async () => {
  const response = await api.get(`${API_ROUTES.amenities.base}/my-bookings`);
  return response.data?.data || [];
};

export const updateBookingStatus = async (id, status) => {
  const response = await api.patch(`${API_ROUTES.amenities.base}/bookings/${id}/status`, { booking_status: status });
  return response.data;
};

export const deleteAmenity = async (id) => {
  const response = await api.delete(`${API_ROUTES.amenities.base}/${id}`);
  return response.data;
};
